import React from 'react';
import ErrorPage from './ErrorPage';

const Error401 = () => <ErrorPage code={401} />;

export default Error401;
